import { combineEpics } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { filter, switchMap, withLatestFrom } from 'rxjs/operators';
import { isActionOf } from 'typesafe-actions';

import { logoutAsync } from '@bolteu/redux-session';
import {
  restoreSessionAsync,
  updateAccessTokenAsync,
} from '@bolteu/redux-session/build/src/actions';
import { logoutEpic } from '@bolteu/redux-session/build/src/epics/logoutEpic';

import { GlobalAppActions } from 'rdx/actions';
import { GlobalAppState } from 'rdx/state';

const restoreSessionFailureEpic = (
  action$: Observable<GlobalAppActions>,
  state$: Observable<GlobalAppState>,
): Observable<GlobalAppActions> => {
  return action$.pipe(
    filter(isActionOf(restoreSessionAsync.failure)),
    withLatestFrom(state$),
    switchMap(() => {
      return of(logoutAsync.success());
    }),
  );
};

const updateAccessTokenFailureEpic = (
  action$: Observable<GlobalAppActions>,
  state$: Observable<GlobalAppState>,
): Observable<GlobalAppActions> => {
  return action$.pipe(
    filter(isActionOf(updateAccessTokenAsync.failure)),
    withLatestFrom(state$),
    switchMap(() => {
      return of(logoutAsync.success());
    }),
  );
};

// logoutEpic is typed with redux-session's own action union
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sessionEpic = combineEpics<any, any, GlobalAppState>(
  restoreSessionFailureEpic,
  updateAccessTokenFailureEpic,
  logoutEpic,
);
